module.exports = __webpack_public_path__ + "static/pour.c4f32437.webp";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/a-propos/pour.webp
// module id = 917
// module chunks = 3